/** CoStar.Api.SuitePlacards.Types.ImageArea */
export var ImageArea;
(function (ImageArea) {
    ImageArea[ImageArea["Unknown"] = 0] = "Unknown";
    ImageArea[ImageArea["Placard"] = 1] = "Placard";
    ImageArea[ImageArea["ImageAlley"] = 2] = "ImageAlley";
})(ImageArea || (ImageArea = {}));
/** CoStar.Api.SuitePlacards.Types.ExternalReferenceType */
export var ExternalReferenceType;
(function (ExternalReferenceType) {
    ExternalReferenceType[ExternalReferenceType["None"] = 0] = "None";
    ExternalReferenceType[ExternalReferenceType["LoopNetAttachment"] = 5] = "LoopNetAttachment";
    ExternalReferenceType[ExternalReferenceType["MatterportScan"] = 36] = "MatterportScan";
    ExternalReferenceType[ExternalReferenceType["Vidly"] = 42] = "Vidly";
    ExternalReferenceType[ExternalReferenceType["CoStarAttachmentHandlerDocument"] = 60] = "CoStarAttachmentHandlerDocument";
})(ExternalReferenceType || (ExternalReferenceType = {}));
import { CurrencyType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuitePlacards.Types.CurrencyType */
export { CurrencyType };
import { ItemType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuitePlacards.Types.ItemType */
export { ItemType };
import { AreaMeasure } from "../../../../CoStar/Api/AnalyticReports/Common/index.js";
/** CoStar.Api.SuitePlacards.Types.AreaMeasure */
export { AreaMeasure };
import { SaleType } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuitePlacards.Types.SaleType */
export { SaleType };
import { SpaceUse } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuitePlacards.Types.SpaceUse */
export { SpaceUse };
import { HotelClass } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuitePlacards.Types.HotelClass */
export { HotelClass };
/** CoStar.Api.SuitePlacards.Types.HotelOperation */
export var HotelOperation;
(function (HotelOperation) {
    HotelOperation[HotelOperation["None"] = 0] = "None";
    HotelOperation[HotelOperation["ChainManagement"] = 1] = "ChainManagement";
    HotelOperation[HotelOperation["Franchise"] = 2] = "Franchise";
    HotelOperation[HotelOperation["Independent"] = 3] = "Independent";
})(HotelOperation || (HotelOperation = {}));
import { HotelScale } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuitePlacards.Types.HotelScale */
export { HotelScale };
import { PropertyGroupType } from "../../../../CoStar/Api/Analytics/CommonEntities/Enums/index.js";
/** CoStar.Api.SuitePlacards.Types.PropertyGroupType */
export { PropertyGroupType };
/** CoStar.Api.SuitePlacards.Types.PropertyGroupSubtype */
export var PropertyGroupSubtype;
(function (PropertyGroupSubtype) {
    PropertyGroupSubtype[PropertyGroupSubtype["None"] = 0] = "None";
    PropertyGroupSubtype[PropertyGroupSubtype["AirportRetail"] = 1] = "AirportRetail";
    PropertyGroupSubtype[PropertyGroupSubtype["CommunityCenter"] = 2] = "CommunityCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["LifestyleCenter"] = 3] = "LifestyleCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["NeighborhoodCenter"] = 4] = "NeighborhoodCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["OutletCenter"] = 5] = "OutletCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["PowerCenter"] = 6] = "PowerCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["RegionalMall"] = 7] = "RegionalMall";
    PropertyGroupSubtype[PropertyGroupSubtype["ThemeFestivalCenter"] = 8] = "ThemeFestivalCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["StripCenter"] = 9] = "StripCenter";
    PropertyGroupSubtype[PropertyGroupSubtype["SuperRegionalMall"] = 10] = "SuperRegionalMall";
    PropertyGroupSubtype[PropertyGroupSubtype["RegionalPrime"] = 11] = "RegionalPrime";
    PropertyGroupSubtype[PropertyGroupSubtype["MajorUrbanCentre"] = 12] = "MajorUrbanCentre";
    PropertyGroupSubtype[PropertyGroupSubtype["UrbanCentre"] = 13] = "UrbanCentre";
    PropertyGroupSubtype[PropertyGroupSubtype["District"] = 14] = "District";
    PropertyGroupSubtype[PropertyGroupSubtype["SolusUnit"] = 15] = "SolusUnit";
    PropertyGroupSubtype[PropertyGroupSubtype["ShoppingPark"] = 16] = "ShoppingPark";
    PropertyGroupSubtype[PropertyGroupSubtype["RetailPark"] = 17] = "RetailPark";
    PropertyGroupSubtype[PropertyGroupSubtype["LeisurePark"] = 18] = "LeisurePark";
    PropertyGroupSubtype[PropertyGroupSubtype["OfficePark"] = 18] = "OfficePark";
    PropertyGroupSubtype[PropertyGroupSubtype["IndustrialPark"] = 18] = "IndustrialPark";
})(PropertyGroupSubtype || (PropertyGroupSubtype = {}));
import { PropertySubtype } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuitePlacards.Types.PropertySubtype */
export { PropertySubtype };
/** CoStar.Api.SuitePlacards.Types.PropertyType */
export var PropertyType;
(function (PropertyType) {
    PropertyType[PropertyType["None"] = 0] = "None";
    PropertyType[PropertyType["Hospitality"] = 1] = "Hospitality";
    PropertyType[PropertyType["Industrial"] = 2] = "Industrial";
    PropertyType[PropertyType["Land"] = 3] = "Land";
    PropertyType[PropertyType["Office"] = 5] = "Office";
    PropertyType[PropertyType["GeneralRetail"] = 6] = "GeneralRetail";
    PropertyType[PropertyType["Flex"] = 7] = "Flex";
    PropertyType[PropertyType["SportsAndEntertainment"] = 8] = "SportsAndEntertainment";
    PropertyType[PropertyType["MixedUse"] = 9] = "MixedUse";
    PropertyType[PropertyType["Specialty"] = 10] = "Specialty";
    PropertyType[PropertyType["Multifamily"] = 11] = "Multifamily";
    PropertyType[PropertyType["Healthcare"] = 13] = "Healthcare";
    PropertyType[PropertyType["Unknown"] = 14] = "Unknown";
    PropertyType[PropertyType["Student"] = 31] = "Student";
})(PropertyType || (PropertyType = {}));
import { ConstructionStatus } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuitePlacards.Types.ConstructionStatus */
export { ConstructionStatus };
import { LandType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuitePlacards.Types.LandType */
export { LandType };
/** CoStar.Api.SuitePlacards.Types.SaleCondition */
export var SaleCondition;
(function (SaleCondition) {
    SaleCondition[SaleCondition["None"] = 0] = "None";
    SaleCondition[SaleCondition["DistressSale"] = 1] = "DistressSale";
    SaleCondition[SaleCondition["TenThirtyOneExchange"] = 2] = "TenThirtyOneExchange";
    SaleCondition[SaleCondition["SaleLeaseback"] = 3] = "SaleLeaseback";
    SaleCondition[SaleCondition["GroundLeaseLeasehold"] = 4] = "GroundLeaseLeasehold";
    SaleCondition[SaleCondition["GroundLeaseLeasedFee"] = 5] = "GroundLeaseLeasedFee";
    SaleCondition[SaleCondition["InvestmentTripleNet"] = 6] = "InvestmentTripleNet";
    SaleCondition[SaleCondition["DirectExchange"] = 7] = "DirectExchange";
    SaleCondition[SaleCondition["Assemblage"] = 8] = "Assemblage";
    SaleCondition[SaleCondition["AuctionSale"] = 9] = "AuctionSale";
    SaleCondition[SaleCondition["BuildToSuit"] = 11] = "BuildToSuit";
    SaleCondition[SaleCondition["BulkPortfolioSale"] = 12] = "BulkPortfolioSale";
    SaleCondition[SaleCondition["BusinessValueIncluded"] = 13] = "BusinessValueIncluded";
    SaleCondition[SaleCondition["CondoConversion"] = 14] = "CondoConversion";
    SaleCondition[SaleCondition["DeedRestriction"] = 15] = "DeedRestriction";
    SaleCondition[SaleCondition["EstateProbateSale"] = 16] = "EstateProbateSale";
    SaleCondition[SaleCondition["HistoricalSite"] = 17] = "HistoricalSite";
    SaleCondition[SaleCondition["LeaseOption"] = 18] = "LeaseOption";
    SaleCondition[SaleCondition["BuildingContaminationIssue"] = 19] = "BuildingContaminationIssue";
    SaleCondition[SaleCondition["DeferredMaintenance"] = 20] = "DeferredMaintenance";
    SaleCondition[SaleCondition["DoubleEscrow"] = 21] = "DoubleEscrow";
    SaleCondition[SaleCondition["ExerciseOfOption"] = 22] = "ExerciseOfOption";
    SaleCondition[SaleCondition["ExcessLand"] = 23] = "ExcessLand";
    SaleCondition[SaleCondition["Expansion"] = 24] = "Expansion";
    SaleCondition[SaleCondition["HighVacancyProperty"] = 25] = "HighVacancyProperty";
    SaleCondition[SaleCondition["LandContract"] = 26] = "LandContract";
    SaleCondition[SaleCondition["PartialInterestTransfer"] = 27] = "PartialInterestTransfer";
    SaleCondition[SaleCondition["PurchaseByTenant"] = 28] = "PurchaseByTenant";
    SaleCondition[SaleCondition["RedevelopmentProject"] = 29] = "RedevelopmentProject";
    SaleCondition[SaleCondition["RollingOptionTakedown"] = 30] = "RollingOptionTakedown";
    SaleCondition[SaleCondition["SoilContaminationIssue"] = 31] = "SoilContaminationIssue";
    SaleCondition[SaleCondition["BuildingInShellCondition"] = 32] = "BuildingInShellCondition";
    SaleCondition[SaleCondition["RealEstateOwned"] = 33] = "RealEstateOwned";
    SaleCondition[SaleCondition["ShortSale"] = 34] = "ShortSale";
    SaleCondition[SaleCondition["ThreatOfCondemnation"] = 35] = "ThreatOfCondemnation";
    SaleCondition[SaleCondition["CourtAppointedSale"] = 36] = "CourtAppointedSale";
    SaleCondition[SaleCondition["Recapitalization"] = 37] = "Recapitalization";
    SaleCondition[SaleCondition["DebtAssumption"] = 38] = "DebtAssumption";
    SaleCondition[SaleCondition["NotePurchase"] = 39] = "NotePurchase";
    SaleCondition[SaleCondition["BankruptcySale"] = 40] = "BankruptcySale";
    SaleCondition[SaleCondition["ZeroCashFlowInvestment"] = 41] = "ZeroCashFlowInvestment";
    SaleCondition[SaleCondition["LowIncomeHousingTaxCredit"] = 42] = "LowIncomeHousingTaxCredit";
    SaleCondition[SaleCondition["EntityBuyMembershipInterests"] = 43] = "EntityBuyMembershipInterests";
    SaleCondition[SaleCondition["CondoDeconversion"] = 44] = "CondoDeconversion";
})(SaleCondition || (SaleCondition = {}));
/** CoStar.Api.SuitePlacards.Types.BelowMarketSaleReason */
export var BelowMarketSaleReason;
(function (BelowMarketSaleReason) {
    BelowMarketSaleReason[BelowMarketSaleReason["None"] = 0] = "None";
    BelowMarketSaleReason[BelowMarketSaleReason["AssignmentOfBeneficialInterestDeed"] = 1] = "AssignmentOfBeneficialInterestDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["AffidavitOfDeath"] = 2] = "AffidavitOfDeath";
    BelowMarketSaleReason[BelowMarketSaleReason["AssignmentOfLease"] = 4] = "AssignmentOfLease";
    BelowMarketSaleReason[BelowMarketSaleReason["BusinessSaleZeroReallocation"] = 7] = "BusinessSaleZeroReallocation";
    BelowMarketSaleReason[BelowMarketSaleReason["ChangeInTitleVesting"] = 8] = "ChangeInTitleVesting";
    BelowMarketSaleReason[BelowMarketSaleReason["ContractInstallmentSale"] = 9] = "ContractInstallmentSale";
    BelowMarketSaleReason[BelowMarketSaleReason["CorrectionDeed"] = 10] = "CorrectionDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["DatedSalePrice"] = 11] = "DatedSalePrice";
    BelowMarketSaleReason[BelowMarketSaleReason["DeedInLieuOfForeclosure"] = 12] = "DeedInLieuOfForeclosure";
    BelowMarketSaleReason[BelowMarketSaleReason["DevelopmentAuthoritySale"] = 13] = "DevelopmentAuthoritySale";
    BelowMarketSaleReason[BelowMarketSaleReason["EasementRightOfWay"] = 15] = "EasementRightOfWay";
    BelowMarketSaleReason[BelowMarketSaleReason["GiftDeed"] = 16] = "GiftDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["InterrelatedParties"] = 17] = "InterrelatedParties";
    BelowMarketSaleReason[BelowMarketSaleReason["MortgageReleaseOfMortgage"] = 21] = "MortgageReleaseOfMortgage";
    BelowMarketSaleReason[BelowMarketSaleReason["PackageSaleRandomAllocation"] = 25] = "PackageSaleRandomAllocation";
    BelowMarketSaleReason[BelowMarketSaleReason["PartnershipDissolution"] = 27] = "PartnershipDissolution";
    BelowMarketSaleReason[BelowMarketSaleReason["QuitclaimDeed"] = 28] = "QuitclaimDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["Rerecording"] = 29] = "Rerecording";
    BelowMarketSaleReason[BelowMarketSaleReason["RedevelopmentAgencySale"] = 30] = "RedevelopmentAgencySale";
    BelowMarketSaleReason[BelowMarketSaleReason["Refinance"] = 31] = "Refinance";
    BelowMarketSaleReason[BelowMarketSaleReason["RelatedPrincipals"] = 32] = "RelatedPrincipals";
    BelowMarketSaleReason[BelowMarketSaleReason["ReleaseOfCosigner"] = 33] = "ReleaseOfCosigner";
    BelowMarketSaleReason[BelowMarketSaleReason["RightOfWay"] = 35] = "RightOfWay";
    BelowMarketSaleReason[BelowMarketSaleReason["TrustDeed"] = 39] = "TrustDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["TrustTransfer"] = 40] = "TrustTransfer";
    BelowMarketSaleReason[BelowMarketSaleReason["TrusteesDeed"] = 41] = "TrusteesDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["UnknownReason"] = 42] = "UnknownReason";
    BelowMarketSaleReason[BelowMarketSaleReason["Foreclosure"] = 43] = "Foreclosure";
    BelowMarketSaleReason[BelowMarketSaleReason["EminentDomain"] = 44] = "EminentDomain";
})(BelowMarketSaleReason || (BelowMarketSaleReason = {}));
import { SaleStatus } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuitePlacards.Types.SaleStatus */
export { SaleStatus };
import { BuildingParkType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuitePlacards.Types.BuildingParkType */
export { BuildingParkType };
/** CoStar.Api.SuitePlacards.Types.LeaseType */
export var LeaseType;
(function (LeaseType) {
    LeaseType[LeaseType["None"] = 0] = "None";
    LeaseType[LeaseType["Direct"] = 1] = "Direct";
    LeaseType[LeaseType["Sublease"] = 2] = "Sublease";
    LeaseType[LeaseType["MonthToMonth"] = 3] = "MonthToMonth";
    LeaseType[LeaseType["Owned"] = 4] = "Owned";
    LeaseType[LeaseType["Assignment"] = 5] = "Assignment";
    LeaseType[LeaseType["Coworking"] = 6] = "Coworking";
})(LeaseType || (LeaseType = {}));
/** CoStar.Api.SuitePlacards.Types.ServiceType */
export var ServiceType;
(function (ServiceType) {
    ServiceType[ServiceType["None"] = 0] = "None";
    ServiceType[ServiceType["PlusCleaning"] = 1] = "PlusCleaning";
    ServiceType[ServiceType["ElectricClean"] = 2] = "ElectricClean";
    ServiceType[ServiceType["PlusElectric"] = 4] = "PlusElectric";
    ServiceType[ServiceType["UtilitiesChar"] = 5] = "UtilitiesChar";
    ServiceType[ServiceType["PlusAllUtilities"] = 6] = "PlusAllUtilities";
    ServiceType[ServiceType["FullServiceGross"] = 7] = "FullServiceGross";
    ServiceType[ServiceType["IndustrialGross"] = 8] = "IndustrialGross";
    ServiceType[ServiceType["ModifiedGross"] = 9] = "ModifiedGross";
    ServiceType[ServiceType["Net"] = 10] = "Net";
    ServiceType[ServiceType["Negotiable"] = 11] = "Negotiable";
    ServiceType[ServiceType["DoubleNet"] = 12] = "DoubleNet";
    ServiceType[ServiceType["TripleNet"] = 13] = "TripleNet";
    ServiceType[ServiceType["ToBeDetermined"] = 14] = "ToBeDetermined";
    ServiceType[ServiceType["TenantElectric"] = 15] = "TenantElectric";
    ServiceType[ServiceType["FullyRepairingInsuring"] = 16] = "FullyRepairingInsuring";
    ServiceType[ServiceType["InternalRepairingOnly"] = 17] = "InternalRepairingOnly";
    ServiceType[ServiceType["InternalRepairingInsuring"] = 18] = "InternalRepairingInsuring";
    ServiceType[ServiceType["FullServiceGrossNoPass"] = 19] = "FullServiceGrossNoPass";
})(ServiceType || (ServiceType = {}));
import { BuildingRating } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuitePlacards.Types.BuildingRating */
export { BuildingRating };
/** CoStar.Api.SuitePlacards.Types.TimeZone */
export var TimeZone;
(function (TimeZone) {
    TimeZone[TimeZone["None"] = 0] = "None";
    TimeZone[TimeZone["PacificHonolulu"] = 1] = "PacificHonolulu";
    TimeZone[TimeZone["AmericaAnchorage"] = 2] = "AmericaAnchorage";
    TimeZone[TimeZone["AmericaLosAngeles"] = 3] = "AmericaLosAngeles";
    TimeZone[TimeZone["UsArizona"] = 4] = "UsArizona";
    TimeZone[TimeZone["AmericaDenver"] = 5] = "AmericaDenver";
    TimeZone[TimeZone["AmericaChicago"] = 6] = "AmericaChicago";
    TimeZone[TimeZone["AmericaNewYork"] = 7] = "AmericaNewYork";
    TimeZone[TimeZone["CanadaAtlantic"] = 8] = "CanadaAtlantic";
    TimeZone[TimeZone["CanadaNewfoundland"] = 9] = "CanadaNewfoundland";
    TimeZone[TimeZone["AmericaGodthab"] = 10] = "AmericaGodthab";
    TimeZone[TimeZone["AtlanticAzores"] = 11] = "AtlanticAzores";
    TimeZone[TimeZone["Greenwich"] = 12] = "Greenwich";
    TimeZone[TimeZone["EuropeBerlin"] = 13] = "EuropeBerlin";
})(TimeZone || (TimeZone = {}));
import { AvailabilityType } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuitePlacards.Types.AvailabilityType */
export { AvailabilityType };
/** CoStar.Api.SuitePlacards.Types.BuildOutStatusType */
export var BuildOutStatusType;
(function (BuildOutStatusType) {
    BuildOutStatusType[BuildOutStatusType["None"] = 0] = "None";
    BuildOutStatusType[BuildOutStatusType["RawSpace"] = 1] = "RawSpace";
    BuildOutStatusType[BuildOutStatusType["ShellSpace"] = 2] = "ShellSpace";
    BuildOutStatusType[BuildOutStatusType["PartialBuildOut"] = 3] = "PartialBuildOut";
    BuildOutStatusType[BuildOutStatusType["FullBuildOut"] = 4] = "FullBuildOut";
    BuildOutStatusType[BuildOutStatusType["SpecSuite"] = 5] = "SpecSuite";
})(BuildOutStatusType || (BuildOutStatusType = {}));
/** CoStar.Api.SuitePlacards.Types.BuildOutConditionType */
export var BuildOutConditionType;
(function (BuildOutConditionType) {
    BuildOutConditionType[BuildOutConditionType["None"] = 0] = "None";
    BuildOutConditionType[BuildOutConditionType["PartiallyDemolished"] = 1] = "PartiallyDemolished";
    BuildOutConditionType[BuildOutConditionType["NeedsRenovation"] = 2] = "NeedsRenovation";
    BuildOutConditionType[BuildOutConditionType["Average"] = 3] = "Average";
    BuildOutConditionType[BuildOutConditionType["Excellent"] = 4] = "Excellent";
    BuildOutConditionType[BuildOutConditionType["Trophy"] = 5] = "Trophy";
    BuildOutConditionType[BuildOutConditionType["Renovated"] = 6] = "Renovated";
})(BuildOutConditionType || (BuildOutConditionType = {}));
import { SpaceType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuitePlacards.Types.SpaceType */
export { SpaceType };
/** CoStar.Api.SuitePlacards.Types.ListingType */
export var ListingType;
(function (ListingType) {
    ListingType[ListingType["None"] = 0] = "None";
    ListingType[ListingType["PropertyForSale"] = 9] = "PropertyForSale";
    ListingType[ListingType["ResidentialPropertyForSale"] = 10] = "ResidentialPropertyForSale";
    ListingType[ListingType["CondoForSale"] = 11] = "CondoForSale";
    ListingType[ListingType["LandForSale"] = 12] = "LandForSale";
    ListingType[ListingType["CommercialPortfolioForSale"] = 13] = "CommercialPortfolioForSale";
    ListingType[ListingType["PropertyDirectSpaceForLease"] = 14] = "PropertyDirectSpaceForLease";
    ListingType[ListingType["ConsolidatedCondosForSale"] = 15] = "ConsolidatedCondosForSale";
    ListingType[ListingType["BuildingParkDirectSpaceLease"] = 16] = "BuildingParkDirectSpaceLease";
    ListingType[ListingType["ShoppingCenterDirectSpaceForLease"] = 17] = "ShoppingCenterDirectSpaceForLease";
    ListingType[ListingType["LandDirectForLease"] = 18] = "LandDirectForLease";
    ListingType[ListingType["CommercialSublease"] = 19] = "CommercialSublease";
    ListingType[ListingType["CommercialLeaseAssignment"] = 20] = "CommercialLeaseAssignment";
    ListingType[ListingType["PropertyCoWorking"] = 21] = "PropertyCoWorking";
    ListingType[ListingType["PropertyForAuction"] = 22] = "PropertyForAuction";
    ListingType[ListingType["LandForAuction"] = 23] = "LandForAuction";
    ListingType[ListingType["CondoForAuction"] = 24] = "CondoForAuction";
    ListingType[ListingType["PropertyLoanForAuction"] = 25] = "PropertyLoanForAuction";
    ListingType[ListingType["CommercialPortfolioForAuction"] = 26] = "CommercialPortfolioForAuction";
})(ListingType || (ListingType = {}));
/** CoStar.Api.SuitePlacards.Types.AdLevel */
export var AdLevel;
(function (AdLevel) {
    AdLevel[AdLevel["None"] = 0] = "None";
    AdLevel[AdLevel["Premium"] = 1] = "Premium";
    AdLevel[AdLevel["Gold"] = 2] = "Gold";
    AdLevel[AdLevel["Platinum"] = 3] = "Platinum";
    AdLevel[AdLevel["Diamond"] = 4] = "Diamond";
})(AdLevel || (AdLevel = {}));
/** CoStar.Api.SuitePlacards.Types.Exposure */
export var Exposure;
(function (Exposure) {
    Exposure[Exposure["None"] = 0] = "None";
    Exposure[Exposure["Base"] = 1] = "Base";
    Exposure[Exposure["Obfuscated"] = 2] = "Obfuscated";
    Exposure[Exposure["Disconnected"] = 3] = "Disconnected";
})(Exposure || (Exposure = {}));
/** CoStar.Api.SuitePlacards.Types.UnitMix */
export var UnitMix;
(function (UnitMix) {
    UnitMix[UnitMix["None"] = 0] = "None";
    UnitMix[UnitMix["Studio"] = 1] = "Studio";
    UnitMix[UnitMix["OneBed"] = 2] = "OneBed";
    UnitMix[UnitMix["TwoBed"] = 4] = "TwoBed";
    UnitMix[UnitMix["ThreeBed"] = 8] = "ThreeBed";
    UnitMix[UnitMix["FourBed"] = 16] = "FourBed";
})(UnitMix || (UnitMix = {}));
import { ApartmentRentType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuitePlacards.Types.ApartmentRentType */
export { ApartmentRentType };
import { ApartmentStyleType } from "../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.SuitePlacards.Types.ApartmentStyleType */
export { ApartmentStyleType };
import { RentBasis } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuitePlacards.Types.RentBasis */
export { RentBasis };
import { RentType } from "../../../../CoStar/Api/SuiteDetail/Types/index.js";
/** CoStar.Api.SuitePlacards.Types.RentType */
export { RentType };
/** CoStar.Api.SuitePlacards.Types.RateUnitMeasure */
export var RateUnitMeasure;
(function (RateUnitMeasure) {
    RateUnitMeasure[RateUnitMeasure["SquareFoot"] = 0] = "SquareFoot";
    RateUnitMeasure[RateUnitMeasure["Acre"] = 1] = "Acre";
})(RateUnitMeasure || (RateUnitMeasure = {}));
import { PropertyLevel } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuitePlacards.Types.PropertyLevel */
export { PropertyLevel };
/** CoStar.Api.SuitePlacards.Types.Availability */
export var Availability;
(function (Availability) {
    Availability[Availability["None"] = 0] = "None";
    Availability[Availability["Lease"] = 1] = "Lease";
    Availability[Availability["Sale"] = 2] = "Sale";
})(Availability || (Availability = {}));
/** CoStar.Api.SuitePlacards.Types.OccupancyType */
export var OccupancyType;
(function (OccupancyType) {
    OccupancyType[OccupancyType["None"] = 0] = "None";
    OccupancyType[OccupancyType["Leased"] = 1] = "Leased";
    OccupancyType[OccupancyType["Subleased"] = 2] = "Subleased";
    OccupancyType[OccupancyType["Owned"] = 3] = "Owned";
    OccupancyType[OccupancyType["Assignment"] = 4] = "Assignment";
    OccupancyType[OccupancyType["Coworking"] = 5] = "Coworking";
})(OccupancyType || (OccupancyType = {}));
import { IndustryType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuitePlacards.Types.IndustryType */
export { IndustryType };
